/**
 * Match Confidence Badge Component
 * Displays the DealerBuilt match confidence level with appropriate styling
 */

import React from 'react';
import { MatchConfidence, MATCH_CONFIDENCE_CONFIG } from '../../types/insurance';

interface MatchConfidenceBadgeProps {
  confidence: MatchConfidence;
  size?: 'sm' | 'md';
  showLabel?: boolean;
}

export const MatchConfidenceBadge: React.FC<MatchConfidenceBadgeProps> = ({
  confidence,
  size = 'md',
  showLabel = true,
}) => {
  const config = MATCH_CONFIDENCE_CONFIG[confidence];

  const sizeClasses = size === 'sm'
    ? 'text-xs'
    : 'text-sm';

  const iconSize = size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4';

  const renderIcon = () => {
    switch (config.icon) {
      case 'check':
        return (
          <svg className={iconSize} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        );
      case 'warning':
        return (
          <svg className={iconSize} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        );
      case 'x':
        return (
          <svg className={iconSize} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        );
    }
  };

  return (
    <span
      className={`inline-flex items-center gap-1 font-medium ${config.color} ${sizeClasses}`}
      title={`DealerBuilt match: ${config.label}`}
    >
      {renderIcon()}
      {showLabel && <span>{config.label}</span>}
    </span>
  );
};

export default MatchConfidenceBadge;
